import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punemumbaidaillycabservice() {



const cardData = {
  keyword: " Pune Mumbai Daily Cab Service ",

headingDescription: "Velocity Cab provides reliable and comfortable Pune to Mumbai daily cab service, ensuring hassle-free and punctual travel for professionals, business travelers, and regular commuters. Our professional drivers, well-maintained vehicles, and timely pickups make the daily commute between Pune and Mumbai smooth and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Pune to Mumbai daily cab travel.",

topPlaces: [
  {
    title: "Pune Railway Station",
    description: "Pune Railway Station is one of the busiest transportation hubs in the city and a common pickup point for Pune–Mumbai daily cab services. Travelers can conveniently begin their journey with comfortable sedan cabs offering timely pickups and door-to-door transfers."
  },
  {
    title: "Shivajinagar",
    description: "Shivajinagar is a prominent commercial and residential area in Pune, making it a popular pickup and drop location for daily cab services to Mumbai. Travelers can enjoy convenient doorstep transportation with flexible scheduling."
  },
  {
    title: "Hinjewadi",
    description: "Hinjewadi is Pune’s leading IT hub and one of the busiest locations for corporate commuters traveling to Mumbai. Daily sedan cab services provide reliable transportation for business professionals with comfortable and punctual rides."
  },
  {
    title: "Wakad",
    description: "Wakad is a rapidly growing residential and commercial locality in Pune that serves as a convenient pickup point for Mumbai-bound cab services. Travelers benefit from hassle-free door-to-door transportation."
  },
  {
    title: "Baner",
    description: "Baner is a popular residential and business area in Pune, frequently chosen by travelers booking daily cab services to Mumbai. Comfortable sedan cabs ensure smooth travel for both personal and corporate trips."
  },
  {
    title: "Kharadi",
    description: "Kharadi is a major IT and business district in Pune, making it a preferred pickup location for professionals commuting to Mumbai. Daily cab services offer safe, comfortable, and timely travel throughout the week."
  },
  {
    title: "Pune Airport",
    description: "Pune Airport is a key transportation hub where travelers often book daily cab services to Mumbai. Sedan cabs provide reliable airport transfers with convenient pickups and comfortable intercity travel."
  },
  {
    title: "Navi Mumbai",
    description: "Navi Mumbai is a major destination for travelers using Pune–Mumbai daily cab services. Comfortable sedan cabs provide direct drop-offs to residential areas, business parks, and commercial centers across the city."
  },
  {
    title: "Bandra",
    description: "Bandra is one of Mumbai’s busiest commercial and residential neighborhoods, frequently served by daily cab services from Pune. Travelers enjoy direct, hassle-free transportation with flexible pickup and drop options."
  },
  {
    title: "Mumbai Airport",
    description: "Mumbai Airport is a popular drop-off destination for Pune–Mumbai daily cab travelers. Sedan cab services ensure timely arrivals for domestic and international flights with comfortable door-to-door transportation."
  }
],



services: [
{
name: "Pune Mumbai Daily Cab Rates",
description: "Pune to Mumbai daily cab rates are designed to offer affordable and flexible pricing for frequent travelers commuting between the two cities. This service is widely used by corporate professionals, business travelers, and daily commuters who require reliable transport. Customers can choose from budget sedan options or premium vehicles like Ertiga and Innova Crysta based on their comfort needs. Transparent pricing includes toll charges, driver allowance, and per km rates with no hidden costs. Smooth connectivity via the Mumbai–Pune Expressway ensures faster travel time and a comfortable ride. Easy online booking and customizable travel schedules make this service highly convenient for daily use."
},
{
name: "Pune Mumbai Airport Drop Daily Cab",
description: "Pune to Mumbai airport drop daily cab service provides reliable transportation for passengers traveling to Mumbai Airport on a regular basis. Drivers ensure timely pickup and drop at Terminal 1 and Terminal 2 with real-time traffic and flight tracking. Comfortable air-conditioned vehicles and professional drivers ensure a stress-free airport transfer experience."
},
{
name: "Pune Mumbai Airport Daily One Way Cab",
description: "Pune to Mumbai airport one way cab service offers cost-effective travel for passengers needing a single-direction trip. This service is ideal for airport transfers, business travel, and quick city-to-city movement without return charges. Flexible pickup timings and multiple vehicle options make travel easy and efficient."
},
{
name: "Pune to Dadar Daily Cab Service",
description: "Pune to Dadar daily cab service offers reliable intercity travel for commuters traveling frequently between Pune and central Mumbai. With convenient pickup and drop options, travelers can enjoy smooth and comfortable rides with experienced drivers."
},
{
name: "Pune to Mumbai Cheapest Cab Service",
description: "Pune to Mumbai cheapest cab service provides budget-friendly travel options without compromising on comfort and safety. Sedan vehicles offer economical travel, while SUVs provide extra comfort for families and groups. Transparent pricing ensures value for money."
},
{
name: "Pune to Mumbai Cab Travel Time",
description: "Pune to Mumbai cab travel time typically ranges between 3.5 to 5 hours depending on traffic and route conditions. The Mumbai–Pune Expressway ensures smooth and fast travel, making cab services a preferred option for comfortable intercity travel."
},
{
name: "Pune to Mumbai Daily Cab Contact Number",
description: "Pune to Mumbai daily cab contact number helps travelers quickly connect with reliable cab providers for instant bookings. Customers can easily arrange daily travel services with flexible pickup timings and professional drivers."
},
{
name: "Pune to Mumbai Airport Daily Cab Number",
description: "Pune to Mumbai airport daily cab contact service provides quick booking support for regular airport transfers. Travelers can contact service providers to book reliable and timely cab services."
},
{
name: "Pune to Mumbai Daily Car Hire",
description: "Pune to Mumbai daily car hire service offers flexible vehicle rental options for regular travel. Customers can choose from sedan, Ertiga, and Innova Crysta vehicles with driver support for comfortable journeys."
},
{
name: "Pune to Mumbai Daily Taxi Fare",
description: "Pune to Mumbai daily taxi fare provides clear and transparent pricing for daily commuters. Travelers can choose cost-effective travel plans with no hidden charges, making it easier to manage travel expenses."
},
{
name: "Pimpri Chinchwad to Mumbai Daily Cab Service",
description: "Pimpri Chinchwad to Mumbai daily cab service offers reliable travel for residents of PCMC areas including Pimpri, Chinchwad, and Akurdi. This service ensures smooth and comfortable travel with experienced drivers."
},
{
name: "Pune Mumbai Daily Cab Service",
description: "Pune Mumbai daily cab service provides consistent and dependable transportation for frequent travelers. With flexible schedules and comfortable vehicles, this service is ideal for business and personal travel."
},
{
name: "Mumbai to Pune Best Taxi Service",
description: "Mumbai to Pune best taxi service offers premium travel experience with well-maintained vehicles, professional drivers, and reliable service ensuring safe and comfortable journeys."
},
{
name: "Cheapest Cab Mumbai to Pune",
description: "Cheapest cab Mumbai to Pune service provides economical travel options for passengers looking for budget-friendly transportation. Affordable pricing combined with reliable service ensures value for money."
},
{
name: "Best Cab Service Mumbai to Pune",
description: "Best cab service Mumbai to Pune ensures high-quality travel with clean vehicles, experienced drivers, and timely pickups for a smooth journey."
},
{
name: "Pune to Mumbai Daily Cab Service",
description: "Pune to Mumbai daily cab service offers reliable intercity travel with flexible pickup timings and comfortable vehicles for frequent travelers."
},
{
name: "Pune to Mumbai Daily Cabs",
description: "Pune to Mumbai daily cabs provide multiple vehicle options for travelers with different budget and comfort requirements."
},
{
name: "Pune to Mumbai Daily Taxi Service",
description: "Pune to Mumbai daily taxi service ensures smooth and dependable travel with professional drivers and well-maintained vehicles."
},
{
name: "Pune to Mumbai Daily Cab Booking",
description: "Pune to Mumbai daily cab booking allows passengers to easily reserve taxis online with instant confirmation and flexible scheduling."
},
{
name: "Pune to Mumbai Shared Cab Daily",
description: "Pune to Mumbai shared cab daily service offers economical travel by sharing rides with other passengers, reducing travel costs."
},
{
name: "Pune to Mumbai One Way Cab",
description: "Pune to Mumbai one way cab service provides cost-effective travel for single-direction trips without return charges."
},
{
name: "Pune to Mumbai Taxi Service",
description: "Pune to Mumbai taxi service offers reliable and comfortable intercity travel with experienced drivers and well-maintained vehicles."
}
],

tableData: [
["Pune Mumbai Daily Cab Rates","Pune Mumbai Airport Drop Daily Cab"],
["Pune Mumbai Airport Daily One Way Cab","Pune to Dadar Daily Cab Service"],
["Pune to Mumbai Cheapest Cab Service","Pune to Mumbai Cab Travel Time"],
["Pune to Mumbai Daily Cab Contact Number","Pune to Mumbai Airport Daily Cab Number"],
["Pune to Mumbai Daily Car Hire","Pune to Mumbai Daily Taxi Fare"],
["Pimpri Chinchwad to Mumbai Daily Cab Service","Pune Mumbai Daily Cab Service"],
["Mumbai to Pune Best Taxi Service","Cheapest Cab Mumbai to Pune"],
["Best Cab Service Mumbai to Pune","Pune to Mumbai Daily Cab Service"],
["Pune to Mumbai Daily Cabs","Pune to Mumbai Daily Taxi Service"],
["Pune to Mumbai Daily Cab Booking","Pune to Mumbai Shared Cab Daily"],
["Pune to Mumbai One Way Cab","Pune to Mumbai Taxi Service"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Daily Cab Service",
    WhyChoosedescription: "Velocity Cabs offers dependable Pune to Mumbai daily cab service for office commuters, business travelers, and frequent intercity passengers with timely pickups and consistent service."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel between Pune and Mumbai via the Mumbai Pune Expressway, ensuring safe driving and on-time travel every day."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "Velocity Cabs offers budget-friendly and transparent pricing for Pune Mumbai daily cab bookings. Customers receive clear fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Daily Cab Availability",
    WhyChoosedescription: "Our Pune to Mumbai daily cab service operates round the clock. Whether it’s early morning office travel or late-night return, Velocity Cabs ensures reliable availability anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and stress-free daily travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Monthly Plans",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way daily rides, round-trip bookings, and customized monthly cab plans for regular commuters between Pune and Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals and corporate groups."
  },
  {
    WhyChooseheading: "Trusted Daily Travel Partner",
    WhyChoosedescription: "Velocity Cabs is trusted by many daily commuters for Pune Mumbai travel thanks to punctual drivers, comfortable vehicles, and professional intercity cab service."
  }
]
};

const faqData = [
  { question: "Do you provide Pune to Mumbai daily cab service?", answer: "Yes, Velocity Cabs provides reliable daily cab services between Pune and Mumbai for regular commuters and corporate travelers." },
  { question: "Is Pune Mumbai daily cab service available 24 hours?", answer: "Yes, our daily cab service operates 24/7 to match your travel schedule." },
  { question: "How far is Pune from Mumbai?", answer: "The road distance between Pune and Mumbai is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Which vehicles are available for daily travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way daily cab?", answer: "Yes, we provide one-way as well as round-trip daily cab services between Pune and Mumbai." },
  { question: "Do you offer monthly cab plans?", answer: "Yes, Velocity Cabs offers customized monthly travel plans for daily commuters and corporate clients." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable daily travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Pune Mumbai daily cab services online or through phone booking." },
  { question: "Do you provide pickup from home or office?", answer: "Yes, we provide doorstep pickup from homes, offices, and business locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Deshmukh",
    feedback:
      "Using Velocity Cabs daily from Pune to Mumbai for office travel. Always on time and very comfortable ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Patil",
    feedback:
      "Best daily cab service between Pune and Mumbai. Clean cars and professional drivers make daily commuting easy and stress-free.",
    rating: 5
  }
];






























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const puneMumbaiDailyJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Mumbai Daily Cab Service | Velocity Cabs",
  "description": "Book reliable daily cab services from Pune to Mumbai with Velocity Cabs. One-way, round trip, airport drops, and daily taxi options available. Cars include Innova, Ertiga, and Sedan.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune, Maharashtra, India"
  },
  "serviceType": [
    "Daily Cab Service Pune to Mumbai",
    "Pune to Mumbai Airport Drop Cab",
    "One-way Daily Cab Pune to Mumbai",
    "Round Trip Daily Cab",
    "Outstation Taxi Pune to Mumbai"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pune to Mumbai Daily Cab Service | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book reliable daily cabs from Pune to Mumbai with Velocity Cabs. Options include one-way, round trip, and airport drop cabs. Cars available: Innova, Ertiga, Sedan."
  />
  <script type="application/ld+json">
    {JSON.stringify(puneMumbaiDailyJSON)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/67.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punemumbaidaillycabservice;